import lodash from 'lodash'

import dateUtil from '@/utils/dateUtil'
import i18n from '@/utils/i18n'
import { getFloorIndex } from '@/api/buildings/request'
import { marketingUserTypeCodeToLabel } from './consts'

function appendUniqueLabel (list, label) {
  if (!label || list.includes(label)) return
  list.push(label)
}

/**
 * Human-readable labels for e-Circular `userType` (same rules as ECircularColumnsMixin list column).
 * @param {unknown} val - JSON array or string from API
 * @returns {string}
 */
export function formatECircularUserTypeDisplay (val) {
  let arr = val
  if (typeof val === 'string') {
    try {
      arr = JSON.parse(val)
    } catch (e) {
      arr = []
    }
  }
  if (!Array.isArray(arr)) arr = []
  if (!arr.length) return '--'
  const parts = []
  if (arr.includes('eCir')) appendUniqueLabel(parts, i18n.t('company.contactTable.ecircular'))
  if (arr.includes('fire')) appendUniqueLabel(parts, i18n.t('company.contactTable.fireMarshal'))
  arr.forEach((token) => {
    if (typeof token !== 'string') return
    if (token === 'admin') {
      appendUniqueLabel(parts, i18n.t('eCircular.recipientType.admin'))
      return
    }
    if (token === 'sub' || token === 'subUser') {
      appendUniqueLabel(parts, i18n.t('eCircular.recipientType.sub'))
      return
    }
    if (token === 'contact') {
      appendUniqueLabel(parts, i18n.t('eCircular.recipientType.contact'))
      return
    }
    const mLabel = marketingUserTypeCodeToLabel(token)
    if (mLabel) appendUniqueLabel(parts, mLabel)
    else if (token.startsWith('mkt:')) {
      appendUniqueLabel(parts, token.slice('mkt:'.length))
    }
  })
  return parts.length ? parts.join(', ') : '--'
}

export function sortPremisesDetailListByFloor (premisesDetailList, building, order = 'desc') {
  const premisesWithoutExpired = premisesDetailList.filter(permises => {
    return dateUtil.isEffective(permises.effectiveDate, permises.endDate)
  })
  return lodash.orderBy(premisesWithoutExpired, [premisesDetail => getFloorIndex(building, premisesDetail.floor)], [order])
}

export function sortByIsMarketing (item) {
  return (item.recipients || []).findIndex(r => (r.roleType || []).length > 0) > -1
}

export function sortByTradeNameIgnoreCase (item) {
  return (item.tradeName || '').toUpperCase()
}

export function sortByFloor (item) {
  return item.premisesDetailList && item.premisesDetailList.length
    ? getFloorIndex(item.building, item.premisesDetailList[0].floor)
    : Number.MIN_SAFE_INTEGER
}

function buildCategory (category, deptId) {
  return {
    name: `${category.shortname} - ${category.name}`,
    status: category.status,
    value: {
      shortname: category.shortname,
      categoryId: category.id,
      departmentId: deptId,
    },
    type: category.type,
  }
}

export function getCategoryOptions (depts, valueContainDeptId = false) {
  return depts.map(dept => {
    const deptId = valueContainDeptId ? `${dept.id}` : ''
    const cates = dept.categories
      .sort((a, b) => a.order - b.order)
      .map(cate => buildCategory(cate, deptId))
    return {
      departments: dept.name,
      name: dept.name,
      key: dept.name,
      categories: cates,
    }
  })
}

export function buildCategoryFilterOptions (categories) {
  const options = categories.reduce((accumulator, currentCate) => {
    const cate = buildCategory(currentCate, currentCate.department.id)
    const option = accumulator.find(item => cate.value.departmentId === item.departmentId)
    if (option) {
      if (!option.categories.find(c => c.value.categoryId === cate.value.categoryId)) {
        option.categories.push(cate)
      }
    } else {
      accumulator = [...accumulator, {
        departments: currentCate.department.name,
        departmentId: currentCate.department.id,
        categories: [cate],
      }]
    }
    return accumulator
  }, [])
  return options
}
